import React from "react";
import { Link } from "react-router-dom";
import { HomeContactBG } from "../Images";

const ContactUsFooter = () => {
  return (
    <>
      <div
        className="cta-area"
        style={{ backgroundImage: `url(${HomeContactBG})` }}
      >
        <div className="container">
          <div className="row">
            <div className="cta-content">
              <h1>Contact Us</h1>
              <p>
                19, POLLOCK STREET, 7TH FLOOR, ROOM NO:7 KOLKATA - 700001
                <br /> <Link to="tel:+91 3322627928">+91 3322627928</Link>{" "}
                <Link to="mailto:essexmarinepvtltd@gmail.com">
                  essexmarinepvtltd@gmail.com
                </Link>
              </p>
              <Link to="/contact-us" className="theme-btn">
                Contact Now<i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsFooter;
